export default __webpack_public_path__ + "static/lukaszk-15845b5213f5980d1de7dcc94feabdfd.webp";